import type { RatingRequest } from "@/model/rating";
import httpClient from ".";
import { API_ENDPOINTS } from "./endpoints";

export const fetchRating = async (requestInfo: RatingRequest) => {
  const { token, ...payload } = requestInfo;
  const config = {
    method: "POST",
    url: API_ENDPOINTS.RATING,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept-Version": "1.0",
    },
    data: payload,
  };

  return httpClient.request(config).then((response) => response.data);
};
